import React, { Fragment } from "react"
import img13 from "../../images/service/Crypto Development/2.png";
import ServiceFaq from "../SeviceSinglePage/ServiceFaq";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import GallerySection from "../SeviceSinglePage/GallerySection";

const exchangeServices = [
  {
    title: "Bitcoin Exchange Development",
    content:
      "Our white-label Bitcoin exchange solution combines advanced UI, anti-hacking protocols, and legal compliance to deliver extraordinary performance and security.",
  },
  {
    title: "Cryptocurrency Wallet Development",
    content:
      "We build secure multi-currency crypto wallets with private key access, blockchain transaction logs, and seamless integration with your exchange.",
  },
  {
    title: "Binance Exchange Development",
    content:
      "Feature-rich Binance-style trading with dual trading levels, KYC/AML options, referral programs, gifting features, low fees, and enterprise-grade security.",
  },
  {
    title: "Cryptocurrency Development Service",
    content:
      "We create secure and unique cryptocurrencies, deploy them in real time, and support marketing campaigns across global platforms.",
  },
  {
    title: "Centralized Exchange Development",
    content:
      "Robust centralized exchanges managed by organizations with controlled transactions, enhanced credibility, and top-tier security mechanisms.",
  },
  {
    title: "Decentralized Exchange Development",
    content:
      "Build decentralized exchanges that use peer-to-peer transactions, automated KYC, and greater transparency while preventing market manipulation.",
  },
  {
    title: "P2P Exchange Development",
    content:
      "Launch secure P2P crypto exchanges enabling instant global trading, escrow-based settlements, decentralization, and censorship-free transactions.",
  },
  {
    title: "OTC Trading Platform Development",
    content:
      "Enable private, high-volume, direct crypto asset trading between parties. Our OTC solutions boost revenue and provide secure, large-scale transactions.",
  },
  {
    title: "Security Token Exchange Development",
    content:
      "Develop SEC-compliant STO exchanges with multi-payment integration, API-based transactions, and fast KYC/AML verification for secure fundraising.",
  },
  {
    title: "Hybrid Crypto Exchange Development",
    content:
      "A powerful hybrid model merging centralized and decentralized benefits — continuous liquidity, fast trades, privacy, and enhanced user security.",
  },
  {
    title: "Cryptocurrency Exchange Legal Services",
    content:
      "Complete legal support including documentation, AML/KYC setup, compliance guidance, licensing assistance, and ongoing regulatory support.",
  },
  {
    title: "Cryptocurrency Exchange Marketing Services",
    content:
      "End-to-end marketing solutions including SEO, content, video marketing, social media, market research, and advertising strategies for growth.",
  },
];


const addons = [
  {
    title: "Bot Trading",
    content:
      "An AI-powered trading bot that runs 24/7, automating trades and saving time while optimizing performance.",
  },
  {
    title: "Multi-currency Wallet",
    content:
      "Securely store and manage multiple cryptocurrencies in one smart, low-fee digital wallet.",
  },
  {
    title: "Multi-Lingual Support",
    content:
      "Expand globally with multi-language support, helping your exchange attract and retain worldwide users.",
  },
  {
    title: "Trade Estimator",
    content:
      "Instantly calculate potential profits in real-time, helping traders make informed decisions effortlessly.",
  },
];


const features = [
    {
      title: "Hot Wallet",
      content:
        "A secure and efficient online wallet for storing & managing cryptocurrencies with instant transfer capabilities.",
    },
    {
      title: "OTC Trading",
      content:
        "Enable users to trade cryptocurrencies directly with fast, private, and fully secure peer-to-peer transactions.",
    },
    {
      title: "Atomic Swap",
      content:
        "Instant cross-chain token swapping with no intermediaries, enabling direct decentralized exchange.",
    },
    {
      title: "Real-Time Tracker",
      content:
        "Live cryptocurrency price tracking, market data, trading volume, and analytics for smarter decision-making.",
    },
    {
      title: "Referral Programs",
      content:
        "Reward-based referral system that boosts user engagement, platform growth, and global adoption.",
    },
    {
      title: "Statistical Reports & Charts",
      content:
        "Advanced charts and analytics enabling deep market insights, performance tracking, and risk assessment.",
    },
  ];

const ServiceDetails: React.FC = () => {


    const outcomeItems = [
        "AI-Powered Data Analysis.",
        "Real-Time Analytics.",
        "Scalable Data Infrastructure.",
        "Enterprise System Integration.",
        "Automated Data Processing.",
        "Smart Decision Support.",
    ];


    return (
        <Fragment>
                    <div className='about-page inner-page'>
                        <div className="body_wrap o-clip">
                            <Header />
                            <main>
                                <PageTitle pageTitle="Crypto Exchange" pagesub="Service details" />
                                <section className="service-details pos-rel mt-4">
            <div className="container">
                {/* ========= TITLE & TEXT ========= */}
                <h2 className="details-content-title mb-15">
Cryptocurrency Exchange Development                </h2>

                <p>
Cryptocurrencies have redefined how modern finance works, and a secure, high-performance exchange is now essential for businesses entering the digital asset economy. We develop advanced cryptocurrency exchange platforms that enable seamless trading, robust security, and lightning-fast performance—designed for startups, enterprises, and large-scale financial ecosystems.                </p>

                <p className="mt-30">
Our solutions simplify buying, selling, and swapping digital assets with an intuitive user experience and enterprise-grade backend architecture. Whether you're launching a centralized, decentralized, or hybrid exchange, we ensure real-time trading, liquidity integrations, and compliance-friendly workflows.                </p><p>
Every exchange we build is optimized for revenue generation through features like trading fees, deposit fees, withdrawal fees, advertisements, staking modules, and margin trading capabilities. Our white-label exchange framework accelerates your launch while allowing complete customization to reflect your brand and business logic.              </p>

              <p className="mt-35">
With scalable infrastructure, automated monitoring, and multi-layered security, our exchange platforms empower businesses to operate efficiently and competitively. From order-matching engines to API integrations, every element is engineered for speed, reliability, and growth-ready performance.              </p>

              <h3 className="item_details_info_heading mb-20 mt-20">
                Building next-generation crypto exchanges
              </h3>

              <p className="mb-40">
                We specialize in developing crypto exchanges that combine institutional-grade security with cutting-edge trading innovation. Our solutions support spot trading, futures, perpetual contracts, P2P markets, liquidity aggregation, and automated market maker modules. Whether you are entering the crypto market or expanding your existing ecosystem, our expertise ensures a powerful and future-proof trading environment.
              </p>

              {/* IMAGE + LIST */}
              <div className="row mb-45 align-items-center mt-none-30">
                <div className="col-md-6 mt-30">
                  <img src={img13} alt="Blog" className="single-item-image" />
                </div>

                <div className="col-md-6 mt-30">
                  <ul className="iconlist_block">
                    <li><span className="iconlist_text">High-performance matching engines</span></li>
                    <li><span className="iconlist_text">Multi-layer security protection</span></li>
                    <li><span className="iconlist_text">Liquidity integration modules</span></li>
                    <li><span className="iconlist_text">Scalable multi-chain architecture</span></li>
                    <li><span className="iconlist_text">Automated KYC/AML workflows</span></li>
                    <li><span className="iconlist_text">API-ready ecosystem tools</span></li>
                  </ul>
                </div>
              </div>

              <h3 className="item_details_info_heading mb-25">3 core reasons businesses launch their own exchange</h3>

              <ul className="iconlist_block numlist_block list-unstyled">
                <li><span className="iconlist_text">1. Create sustainable long-term revenue streams</span></li>
                <li><span className="iconlist_text">2. Gain full control over trading operations and user flows</span></li>
                <li><span className="iconlist_text">3. Establish a strong presence in the global digital asset economy</span></li>
              </ul>


              <section className="service pos-rel bg_img">
  <h2 className="details-content-title mt-30 mb-30">
    Cryptocurrency Exchange Development Services
  </h2>

  <div className="container">
    <div className="row mt-none-30">
      {exchangeServices.map((service, index) => (
        <div className="col-lg-6 mt-30" key={index}>
          <div
            className="xb-ser-item xb-border img-hove-effect"
            style={{
              minHeight: "260px",
              transition: "all 0.3s ease",
              transform: "translateY(0)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-10px)";
              e.currentTarget.style.boxShadow =
                "0px 10px 30px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <div
              className="xb-item--inner"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                paddingBottom: "10px",
              }}
            >
              {/* Title */}
              <h3
                className="xb-item--title border-effect"
                style={{ marginBottom: "20px" }}
              >
                {service.title}
              </h3>

              {/* Description */}
              <p className="xb-item--content">{service.content}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


                {/* ========= SERVICE PROCESS ========= */}
                <ServiceFaq />


                {/* ========= SERVICES OUTCOME ========= */}
                <div className="services-outcome-wrap">
                    <h2 className="details-content-title mb-15">Services outcome</h2>
                    <p>
                        We help Fortune 500 companies accelerate innovation through advanced data and intelligence solutions. Using AI, machine learning, and real-time analytics, we turn complex data into actionable insights. Our services empower smarter decisions, improve performance.
                    </p>

                    <ul className="service-outcome-list list-unstyled mt-35">
                        {outcomeItems.map((item, i) => (
                            <li key={i}>
                                <span>
                                    {/* green check icon */}
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            opacity="0.2"
                                            d="M24 12C24 13.024 22.742 13.868 22.49 14.812C22.23 15.788 22.888 17.148 22.394 18.002C21.892 18.87 20.382 18.974 19.678 19.678C18.974 20.382 18.87 21.892 18.002 22.394C17.148 22.888 15.788 22.23 14.812 22.49C13.868 22.742 13.024 24 12 24C10.976 24 10.132 22.742 9.188 22.49C8.212 22.23 6.852 22.888 5.998 22.394C5.13 21.892 5.026 20.382 4.322 19.678C3.618 18.974 2.108 18.87 1.606 18.002C1.112 17.148 1.77 15.788 1.51 14.812C1.258 13.868 0 13.024 0 12C0 10.976 1.258 10.132 1.51 9.188C1.77 8.212 1.112 6.852 1.606 5.998C2.108 5.13 3.618 5.026 4.322 4.322C5.026 3.618 5.13 2.108 5.998 1.606C6.852 1.112 8.212 1.77 9.188 1.51C10.132 1.258 10.976 0 12 0C13.024 0 13.868 1.258 14.812 1.51C15.788 1.77 17.148 1.112 18.002 1.606C18.87 2.108 18.974 3.618 19.678 4.322C20.382 5.026 21.892 5.13 22.394 5.998C22.888 6.852 22.23 8.212 22.49 9.188C22.742 10.132 24 10.976 24 12Z"
                                            fill="#ff8c00ff"
                                        />
                                        <path
                                            d="M15.5559 9.14076L11.3992 13.178L9.24437 11.0869C8.77664 10.6326 8.01773 10.6326 7.55001 11.0869C7.08229 11.5412 7.08229 12.2783 7.55001 12.7326L10.5729 15.6686C11.0279 16.1105 11.7668 16.1105 12.2218 15.6686L17.2484 10.7864C17.7162 10.3321 17.7162 9.59504 17.2484 9.14076C16.7807 8.68648 16.0236 8.68648 15.5559 9.14076Z"
                                            fill="#ff8c00ff"
                                        />
                                    </svg>
                                </span>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

               <section className="service pos-rel bg_img">
  <h2 className="details-content-title mt-40 mb-30">Ideal Features</h2>

  <div className="container">
    <div className="row mt-none-30">
      {features.map((feature, index) => (
        <div className="col-lg-6 mt-30" key={index}>
          <div
  className="xb-ser-item xb-border img-hove-effect"
  style={{
    minHeight: "260px",
    transition: "all 0.3s ease",
    transform: "translateY(0)",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-10px)";
    e.currentTarget.style.boxShadow = "0px 10px 30px rgba(0,0,0,0.15)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";
  }}
>

            {/* ⭐ FLEX WRAPPER — pushes title up & description down */}
            <div
              className="xb-item--inner"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                paddingBottom: "10px",
              }}
            >
              {/* Title (top) */}
              <h3 className="xb-item--title border-effect" style={{ marginBottom: "20px" }}>
                {feature.title}
              </h3>

              {/* Description (bottom) */}
              <p className="xb-item--content">
                {feature.content}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

<section className="service pos-rel bg_img">
  <h2 className="details-content-title mt-40 mb-30">Add-On Features</h2>

  <div className="container">
    <div className="row mt-none-30">
      {addons.map((item, index) => (
        <div className="col-lg-6 mt-30" key={index}>
          <div
            className="xb-ser-item xb-border img-hove-effect"
            style={{
              minHeight: "260px",
              transition: "all 0.3s ease",
              transform: "translateY(0)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-10px)";
              e.currentTarget.style.boxShadow = "0px 10px 30px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            {/* ⭐ FLEX WRAPPER — ensures perfect spacing */}
            <div
              className="xb-item--inner"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                paddingBottom: "10px",
              }}
            >
              {/* Title */}
              <h3
                className="xb-item--title border-effect"
                style={{ marginBottom: "20px" }}
              >
                {item.title}
              </h3>

              {/* Description */}
              <p className="xb-item--content">{item.content}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>



                {/* ========= GALLERY ========= */}
                
                <GallerySection/>

            </div>
        </section>
                            </main>
                            <Footer />
                            <Scrollbar />
                        </div>
                    </div>
                </Fragment>

        
    );
};

export default ServiceDetails;
